import { useTranslation } from 'react-i18next'
import { Box } from '../../../../Common/Box'
import TextInput from '../../../../App/Components/Form/TextInput/TextInput'
import React, { SyntheticEvent, useEffect, useState } from 'react'
import { PasswordText } from './style'
import { Label, LabelText } from './style'
import { IProps } from './IProps'

export const ResetPasswordEditInput = ({
  newPassword,
  setNewPassword,
  confirmPassword,
  setConfirmPassword,
}: IProps) => {
  const { t } = useTranslation()
  const [passwordLengthError, setPasswordLengthError] = useState<string>('')
  const [passwordMatchError, setPasswordMatchError] = useState<string>('')

  useEffect(() => {
    if (confirmPassword !== newPassword) {
      setPasswordMatchError(`${t('Passwords do not match')}`)
    } else {
      setPasswordMatchError('')
    }

    if (confirmPassword.length === 0) {
      setPasswordMatchError('')
    }
  }, [newPassword, confirmPassword, setPasswordMatchError, t])

  return (
    <Box mt={1} mb={1}>
      <Box>
        <Box display={'flex'}>
          <PasswordText> {t('New password')}</PasswordText>
        </Box>
        <TextInput
          type="password"
          onChange={(e: SyntheticEvent<HTMLInputElement>) => {
            setNewPassword(e.currentTarget.value)
            if (e.currentTarget.value.length < 4) {
              setPasswordLengthError(
                `${t('Password must contain 4 characters or more')}`,
              )
            } else {
              setPasswordLengthError('')
              setNewPassword(e.currentTarget.value)
            }
            if (e.currentTarget.value.length === 0) {
              setPasswordLengthError('')
            }
          }}
        />
      </Box>

      <Box>
        <Box display={'flex'}>
          <PasswordText> {t('Confirm password')}</PasswordText>
        </Box>
        <TextInput
          type="password"
          onChange={(e: SyntheticEvent<HTMLInputElement>) => {
            setConfirmPassword(e.currentTarget.value)
          }}
        />
      </Box>

      {passwordLengthError && (
        <Label color={'warning'}>
          <LabelText>{passwordLengthError}</LabelText>
        </Label>
      )}

      {passwordMatchError && (
        <Label color={'error'}>
          <LabelText>{passwordMatchError}</LabelText>
        </Label>
      )}
    </Box>
  )
}
